import React from 'react';

const Minus = ({ ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="24"
        fill="none"
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M15.071 12.7H.93v-1.4H15.07v1.4Z"
            clipRule="evenodd"
        />
    </svg>
);

export default Minus;
